import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";

const PersonalizedProvider = () => {
  const navigate = useNavigate();
  const contract = useSelector((state) => state.userData);
  const token = localStorage.getItem("AccessToken");
  const { t } = useTranslation();
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  useEffect(() => {
    setLoading(true); // Ensure loader shows on every API call
    const fetchBenefits = async () => {
      if (!contract.userData?.EmailID) {
        setLoading(false);
        return; // Prevent unnecessary API calls if EmailID is missing
      }

      const payload = {
        _Params: JSON.stringify({ EmailID: contract.userData.EmailID, MemberID: contract.userData.MemberID, Contract: contract.userData.ContractIdentified, DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal" }),
      };

      try {
        const response = await axios.post(Endpoints.LoadPersonalizedListOfProviders, payload, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        });
        setProviders(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching benefits:", error);
        setProviders([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBenefits();
  }, [contract.userData?.EmailID, token]);

  const handleBackClick = () => {
    navigate("/home");
  };

  const formatPhoneNumber = (phone) => {
    const cleaned = `${phone || ""}`.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return `(${match[1]})${match[2]}.${match[3]}`;
    }

    return phone || "-";
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>
      {isHighmarkPortal ? 
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>       
          <h2 className="page-heading">Personalized Providers</h2>
        </div>:
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
              {t("Back")}
            </span>
          </button>       
          <h2 className="page-heading">Personalized Providers</h2>
        </div>
      }

      <div className="row mt-4">
        {providers.length > 0 ? (
          providers.map((provider, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={provider.GroupID || `${provider.GroupName}-${index}`}>
              <div className="h-100 p-4 border rounded bg-white">
                <h3 className="page-heading-bold-primary-20 mb-3">{provider.GroupName || "-"}</h3>
                <p className="mb-2 text-dark">{provider.Address || "-"}</p>
                <p className="mb-2 text-dark">
                  <span className="fw-normal">Distance:</span>{" "}
                  <span>{provider.DistanceText || provider.Distance || "-"}</span>
                </p>
                {Number(provider.DistanceValue) !== 0 && (
                  <>
                    <p className="mb-2 text-dark">
                      <span className="fw-normal">Phone:</span>{" "}
                      <span className="text-primary-color">{formatPhoneNumber(provider.PhoneNumber || provider.Phone)}</span>
                    </p>
                    {provider.Email && (
                      <p className="mb-2 text-dark">
                        <span className="fw-normal">Email:</span>{" "}
                        <span>{provider.Email}</span>
                      </p>
                    )}
                    {provider.Website && (
                      <p className="mb-0 text-dark">
                        <span className="fw-normal">Website:</span>{" "}
                        <span>{provider.Website}</span>
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center mt-4">
            <p className="text-dark mb-0">No personalized providers are currently available. Please try again later.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default PersonalizedProvider;
